import React, { useCallback, useImperativeHandle, useRef } from "react";
import AddPortfolioMenu from "@features/add/AddPortfolioMenu";
import AddPortfolioModal from "@features/add/AddPortfolioModal";
import { ImportType, ImportTypeRef } from "@features/add/components/types";

export interface AddPortfolioHandle {
  onSelect: (val: ImportType) => void;
}

export const AddPortfolio = ({
  ref,
  menuEl,
  setMenuEl,
  isModalOpen,
  setIsModalOpen,
}: {
  ref?: React.Ref<AddPortfolioHandle>;
  menuEl: HTMLElement | null;
  setMenuEl: (menuEl: HTMLElement | null) => void;
  isModalOpen: boolean;
  setIsModalOpen: (isModalOpen: boolean) => void;
}) => {
  const modalRef = useRef<ImportTypeRef | null>(null);

  const handleCloseMenu = useCallback(() => setMenuEl(null), [setMenuEl]);

  const onSelect = useCallback(
    (val: ImportType) => {
      handleCloseMenu();
      setIsModalOpen(true);
      modalRef.current?.setImportType(val);
    },
    [handleCloseMenu, setIsModalOpen]
  );

  useImperativeHandle(ref, () => ({ onSelect }), [onSelect]);

  return (
    <>
      <AddPortfolioMenu
        menuEl={menuEl}
        handleCloseMenu={handleCloseMenu}
        onSelect={onSelect}
      />
      <AddPortfolioModal
        ref={modalRef}
        isOpen={isModalOpen}
        setIsOpen={setIsModalOpen}
      />
    </>
  );
};
